function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var InvitationLinkTemplate = require('./saito-link.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var InvitationLink = /*#__PURE__*/function () {
  function InvitationLink(app, mod) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, InvitationLink);
    this.app = app;
    this.mod = mod;
    this.data = data;
    this.overlay = new SaitoOverlay(app, mod);
    this.invite_link = '';
    this.share_to_chat = true;
    this.share_to_redsquare = true;
    this.share_to_qr = true;
  }
  return _createClass(InvitationLink, [{
    key: "render",
    value: function render() {
      var display = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.buildLink();
      if (display) {
        this.overlay.show(InvitationLinkTemplate(this.app, this));
        this.attachEvents();
      } else {
        navigator.clipboard.writeText(this.invite_link);
        var game = this.data.name || this.data.game;
        siteMessage("".concat(game, " invite link copied to clipboard"), 2500);
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      try {
        document.querySelector('#copy-invite-link').addEventListener('click', function (e) {
          navigator.clipboard.writeText(_this.invite_link);
          _this.overlay.remove();
        });
      } catch (err) {
        console.error(err);
      }
      if (document.getElementById('chat-invite-link')) {
        document.getElementById('chat-invite-link').onclick = function (e) {
          _this.app.connection.emit('chat-message-user', 'community', _this.invite_link);
          _this.app.connection.emit('open-chat-with');
          _this.overlay.remove();
        };
      }
      if (document.getElementById('tweet-invite-link')) {
        document.getElementById('tweet-invite-link').onclick = function (e) {
          navigator.clipboard.writeText(_this.invite_link);
          _this.overlay.remove();
          _this.app.connection.emit('redsquare-new-post', _this.invite_link);
        };
      }
      if (document.getElementById('qr-invite-link')) {
        document.getElementById('qr-invite-link').onclick = function (e) {
          _this.overlay.remove();
          var qr_overlay = new SaitoOverlay(_this.app, _this.mod);
          var html = "<div class=\"qr-share-overlay\">\n\t\t\t\t<div class=\"qr-share-header\">Scan for ".concat(_this.data.name || _this.data.game, "</div>\n\t\t\t\t<div id=\"qr-share-link\"></div></div>");
          qr_overlay.show(html);
          var data = {
            text: _this.invite_link
          };
          _this.app.browser.generateQRCode(data, 'qr-share-link');
        };
      }
    }
  }, {
    key: "buildLink",
    value: function buildLink() {
      var _this$data;
      this.invite_link = window.location.origin;
      var path = ((_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.path) || window.location.pathname;
      this.invite_link += path;

      //Make sure we have the final /
      if (this.invite_link.slice(-1) != '/') {
        this.invite_link += '/';
      }
      for (var key in this.data) {
        if (key !== 'path' && key !== 'name') {
          var val = this.data[key];
          this.invite_link += '&' + key + '=' + encodeURIComponent(val != null ? val : '');
        }
      }
      this.invite_link = this.invite_link.replace('/&', '/?');
      console.log(this.invite_link);
    }
  }]);
}();
module.exports = InvitationLink;